import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=2b996ad1&"
import script from "./menu.component.ts?vue&type=script&lang=ts&"
export * from "./menu.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports